var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateStatusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.25C14.1421 18.25 17.5 14.8921 17.5 10.75C17.5 6.60786 14.1421 3.25 10 3.25C5.85786 3.25 2.5 6.60786 2.5 10.75C2.5 14.8921 5.85786 18.25 10 18.25Z",
    fill: "white",
    stroke: "#E9A232",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8L10 11",
    stroke: "#E9A232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 14C10.9688 14.535 10.535 14.9688 10 14.9688C9.46497 14.9688 9.03125 14.535 9.03125 14C9.03125 13.465 9.46497 13.0312 10 13.0312C10.535 13.0312 10.9688 13.465 10.9688 14Z",
    fill: "#E9A232",
    stroke: "#E9A232",
    strokeWidth: 0.0625
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateStatusIcon);
export default __webpack_public_path__ + "static/media/updateStatusIcon.fdc2de5f8af8f6af160f97dfe1f6f732.svg";
export { ForwardRef as ReactComponent };